import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class DeliveryMethodDisciplineContinentRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return indexableFilters.length === 3
			&& indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD)
			&& indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES)
			&& indexableFilters.some((_) => _.type === ParameterType.CONTINENT);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.DELIVERY_METHOD_DISCIPLINE_CONTINENT_ROUTE,
			params: {
				delivery_method: this.extractPath(filters.find((_) => _.type === ParameterType.DELIVERY_METHOD)),
				discipline: this.extractPath(filters.find((_) => _.type === ParameterType.DISCIPLINES)),
				continent: this.extractPath(filters.find((_) => _.type === ParameterType.CONTINENT)),
			},
		};
	}
}
